<template>
    <div>                       
        <template v-for="i in variant_item.options">
            - {{i.value}} -
        </template>
        
        <template v-if="listDesign.length > 0">
            <table class="table table-striped">
                <thead  class="thead-dark">
                    <tr>
                        <th width="10%" scope="col">Vendor</th>                        
                        <th width="10%" scope="col">Designer</th>
                        <th width="20%" scope="col">Template</th>
                        <th width="20%" scope="col">Template Size</th>
                        <th width="20%" scope="col">Design</th>
                        <th width="20%" scope="col">Design Size</th>
                    </tr>                    
                </thead >
                <tr v-for="i in listVariants" :key="i.id">
                    <td>{{i.vendor_name}}</td>
                    <td>{{i.designer_username}}</td>
                    <td>
                        <!-- <a :href="i.template_url" v-if="i.template_url != ''" target="_blank" rel="noopener noreferrer>Link Template</a> -->
                        <v-menu
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-x              
                        persistent
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <a
                                    v-bind="attrs"
                                    v-on="on"
                                    v-if="i.template_url != ''"
                                >
                                Link Template
                                </a>
                            </template>
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                            >
                                <div v-for="(j,index) in i.list_template_url" :key="index" style="padding:5px;text-align:left">
                                    <b>({{index + 1}}):</b> {{j}}
                                </div>
                            </v-card>
                        </v-menu>
                    </td>
                    <td>{{i.template_size}}</td>
                    <td><a :href="i.design_url" v-if="i.design_url != ''" target="_blank" rel="noopener noreferrer">Link Design</a></td>
                    <td>{{i.design_size}}</td>
                </tr>
            </table>
            <v-btn small class="white--text" color="warning" @click="cancelData">
                Cancel <v-icon right dark>mdi-window-close</v-icon>
            </v-btn>
        </template>
        <template v-else>
            <p>No Design Available</p>
            <v-btn small class="white--text" color="warning" @click="cancelData">
                Cancel <v-icon right dark>mdi-window-close</v-icon>
            </v-btn>
        </template>
    </div>
</template>

<script>

    export default {
        name:'design-list',
        props:{
            listDesign: Array,
            variant_item: Object,
            listVendors: Array,
            listVariantsReceive: Array,
            type: String,       
        },
        data:() => ({
            listVariants:[],
            listVendorDesign:[],
            count:0,
        }),
        methods:{       
            cancelData(){
                if(this.type == "design")
                {
                    this.$root.$refs.design.offDesignList()
                }else if(this.type == "info"){
                this.$root.$refs.seller.offDesignList()
                }

                if(this.type == "normal_design")
                {
                    this.$root.$refs.normalProductDesigner.offDesignList()
                }else if(this.type == "normal_info"){
                this.$root.$refs.normalProductSeller.offDesignList()
                }
            },

            convertData(){
                var i = this.variant_item.variant_id
                for(const a of this.listDesign){
                    a["selected"] = false
                }

                for(const j of this.listVendors){
                    for(const k of j.design_templates){
                        if(k.variant_id == i){
                            console.log("design_templates: ",k)
                            this.count += 1  
                            var item = {
                                id: this.count,
                                vendor_id: j._id,
                                vendor_code: j.vendor_code,
                                vendor_name: j.vendor_name,
                                designer_username:'',
                                template_url:k.template_url,
                                list_template_url:[],
                                template_size:k.width+"x"+k.height,
                                design_url:'',
                                design_size:'',
                            }
                            this.listVariants.push(item)
                            item = {}
                        }
                    }
                }

                for(const l of this.listDesign){
                    for(const m of this.listVariants){
                        if(m.vendor_id == l.vendor_id){
                            m.design_url = l.design_url
                            m.designer_username = l.designer_username    
                            l.selected = true                        
                        }
                    }
                }

                for(const n of this.listDesign){
                    if(n.selected == false){
                        var vendorTemp = null
                        for(const o of this.listVendors){
                            if(o._id == n.vendor_id){
                                vendorTemp = o
                            }
                        }
                        this.count += 1                      
                        var item1 = {
                            id: this.count,
                            vendor_id: n.vendor_id,
                            vendor_code: vendorTemp.vendor_code,
                            vendor_name: vendorTemp.vendor_name,
                            designer_username:n.designer_username,
                            template_url:'',
                            list_template_url:[],
                            template_size:'',
                            design_url:n.design_url,
                            design_size:'',
                        }
                        this.listVariants.push(item1)
                    }
                }

                for(const o of this.listVariants){
                    const img = new Image();
                    //const img2 = new Image();

                    if(o.design_url){
                        img.src = o.design_url;
                        console.log(img)                    
                        img.onload = function() {
                            console.log(this.width + 'x' + this.height)
                            var a = this.width
                            var b = this.height
                            o.design_size = a + 'x' + b
                        //alert(this.width + 'x' + this.height);
                        }
                    }

                    // if(o.template_url){
                    //     img2.src = o.template_url;
                    //     console.log(img2)                    
                    //     img2.onload = function() {
                    //         console.log(this.width + 'x' + this.height)
                    //         var a = this.width
                    //         var b = this.height
                    //         o.template_size = a + 'x' + b
                    //     //alert(this.width + 'x' + this.height);
                    //     }
                    // }

                    if(o.template_url){
                        o.list_template_url = o.template_url.split(",")
                    }

                    console.log(o)
                }
                console.log('listVariants: ',this.listVariants)
            },
            check(){
                console.log()
            },
        },
        beforeMount(){
            console.log('listVendors',this.listVendors)
            console.log('variant_item',this.variant_item)
            console.log('listDesign',this.listDesign)
            console.log('listVariantsReceive',this.listVariantsReceive)
            this.convertData()
        }   
    }
</script>

<style scoped>
</style>